import cn from 'classnames'
import { PrimaryButton } from '../PrimaryButton'
import React, { useState } from 'react'
import { PricesMobile } from '../../sections/PricesMobile'
import { SelectableCard } from '../SelectableCard'
import { SelectableTariffDropdown } from '../SelectableTariffDropdown'
import { TooltipIcon } from '../TooltipIcon'
import { ToggleCard } from '../ToggleCard'

const TOOLTIP_TEXT = {
  products:
    'Считаем все товары в наличии по добавленным ключам. Количество магазинов не ограничено',
  frequency: 'Как часто сервис будет проверять цены товаров',
  addons: (
    <>
      <strong>Премиум-поддержка</strong>
      <div className="mt-1">
        Выделенный чат с нашей командой. Среднее время ответа — 15 минут. Без
        премиума ответы до 6 часов
      </div>
      <div className="mt-4">
        {' '}
        <strong>Персональное обучение</strong>
        <div className="mt-1">
          Персональное обучение. Подскажем как лучше настроить Мониторинг для
          вашего бизнеса. Неограниченные созвоны в течение первого месяца, чтобы
          вы быстро освоили сервис
        </div>
      </div>
    </>
  ),
  support:
    'Выделенный чат с нашей командой. Среднее время ответа — 15 минут. Без премиума ответы до 6 часов',
  training:
    'Персональное обучение. Подскажем как лучше настроить Мониторинг для вашего бизнеса. Неограниченные созвоны в течение первого месяца, чтобы вы быстро освоили сервис'
}

export const CostList = ({
  search = false,
  freqPrice,
  tariffPrice,
  activePeriod,
  setActivePeriod,
  activeTariff,
  tariffs,
  tariff,
  freq,
  total,
  activeCount,
  activeFreq,
  setActiveCount,
  setActiveFreq,
  extraPrices
}) => {
  const ADDON_ITEMS = [
    {
      key: 'connect',
      title: 'Премиум поддержка',
      priceDelta: extraPrices?.premium_support_price || 0,
      defaultSelected: false,
      tooltipText: TOOLTIP_TEXT.support
    },
    {
      key: 'training',
      title: 'Настройка с\u00A0аналитиком',
      priceDelta: extraPrices?.training_price || 0,
      defaultSelected: false,
      tooltipText: TOOLTIP_TEXT.training
    }
  ]

  const [selectedAddons, setSelectedAddons] = useState(
    new Set(ADDON_ITEMS.filter(a => a.defaultSelected).map(a => a.key))
  )
  const idMonth = activePeriod
  const priceMonthBase = total && activePeriod ? total / activePeriod : 0
  const addonsDeltaPerMonth = Array.from(selectedAddons).reduce((sum, key) => {
    const found = ADDON_ITEMS.find(a => a.key === key)
    if (key === 'training') {
      return sum
    }
    return sum + (found ? found.priceDelta : 0)
  }, 0)
  const trainingPrice =
    selectedAddons.has('training') ?
      ADDON_ITEMS.find(a => a.key === 'training')?.priceDelta || 0
    : 0
  const priceMonthFinal = priceMonthBase + addonsDeltaPerMonth
  const totalFinal = total + addonsDeltaPerMonth * idMonth + trainingPrice
  return (
    <div id="tariffs" className="w-full max-w-[1200px]">
      <div className="bg-[#1B2126] rounded-t-[20px] rounded-b-[10px] lg:rounded-t-[60px] lg:rounded-b-[30px] py-5 lg:p-20 mt-[49px] lg:mt-5 relative">
        <div className="hidden lg:flex space-x-10 justify-between">
          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 1
                </span>
              </div>
              <div>
                <div className="flex items-center justify-between gap-2 mb-3">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Товаров
                  </span>
                  <TooltipIcon text={TOOLTIP_TEXT.products} />
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>

              <SelectableTariffDropdown
                options={tariffs.map(tariff => {
                  const { name, price, count_products } = tariff
                  const resultName = name.split(' ')
                  if (Number.isInteger(+resultName[0])) {
                    resultName[0] = (+resultName[0]).toLocaleString('ru')
                  }
                  return {
                    value: count_products,
                    label: resultName.join(' '),
                    price: price
                  }
                })}
                value={activeCount}
                selectedPrice={tariffPrice}
                onChange={value => {
                  setActiveFreq(1)
                  setActiveCount(value)
                }}
                placeholder="Выберите количество товаров"
              />
            </div>
          </div>
          {!search && (
            <div className="flex flex-grow max-w-[230px] min-w-[230px]">
              <div className="space-y-8 flex-grow">
                <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                  <span className="block text-white text-sm leading-[16px] font-semibold">
                    ШАГ 2
                  </span>
                </div>
                <div>
                  <div className="flex items-center justify-between gap-2 mb-3">
                    <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                      Частота обновления
                    </span>
                    <TooltipIcon text={TOOLTIP_TEXT.frequency} />
                  </div>
                  <div className="h-0.5 bg-white/[7%]" />
                </div>

                <div className="space-y-4">
                  {activeTariff &&
                    activeTariff.frequencies.map(freq => {
                      const { name, price, frequency } = freq
                      const isActive = frequency === activeFreq
                      return (
                        <SelectableCard
                          key={frequency + name}
                          title={name}
                          subtitle={
                            price === -1 ? 'Персонально'
                            : price === 0 ?
                              '0 ₽'
                            : price.toLocaleString('ru') + ' ₽'
                          }
                          checked={isActive}
                          onChange={() => setActiveFreq(frequency)}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
          )}

          {/* ШАГ 3 */}
          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 3
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-3 justify-between">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Доп. опции
                  </span>
                  <TooltipIcon text={TOOLTIP_TEXT.addons} />
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>

              <div className="space-y-4">
                {ADDON_ITEMS.map(item => {
                  const isOn = selectedAddons.has(item.key)
                  const toggle = () => {
                    setSelectedAddons(prev => {
                      const next = new Set(prev)
                      if (next.has(item.key)) {
                        next.delete(item.key)
                      } else {
                        next.add(item.key)
                      }
                      return next
                    })
                  }

                  return (
                    <ToggleCard
                      key={`addon-${item.key}`}
                      title={item.title}
                      subtitle={`${item.priceDelta.toLocaleString('ru')} ₽`}
                      checked={isOn}
                      onChange={toggle}
                      tooltipText={item.tooltipText}
                    />
                  )
                })}
              </div>
            </div>
          </div>
          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 4
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-3 justify-between">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Период действия
                  </span>
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>

              <div className="space-y-4">
                {activeTariff &&
                  activeTariff.frequencies.find(
                    el => el.frequency === activeFreq
                  ) &&
                  activeTariff.frequencies
                    .find(el => el.frequency === activeFreq)
                    .periods.filter(
                      (el, index) => !(activeCount === 10 && index !== 0)
                    )
                    .map((period, index) => {
                      const { name, id } = period
                      const isChecked = id === activePeriod

                      return (
                        <SelectableCard
                          key={id + name}
                          title={name}
                          badge={
                            index !== 0 ?
                              <span className="block text-white text-[12px] px-1 leading-[22px] rounded-[7px] bg-[#C93F38] font-semibold">{`- ${10 + (index - 1) * 5} %`}</span>
                            : null
                          }
                          checked={isChecked}
                          onChange={() => setActivePeriod(id)}
                        />
                      )
                    })}
              </div>
            </div>
          </div>
        </div>
        <PricesMobile
          freqPrice={freqPrice}
          tariffPrice={tariffPrice}
          activePeriod={activePeriod}
          setActivePeriod={setActivePeriod}
          tariffs={tariffs}
          tariff={tariff}
          freq={freq}
          total={totalFinal}
          totalBase={total}
          priceMonth={priceMonthFinal}
          activeCount={activeCount}
          activeFreq={activeFreq}
          setActiveCount={setActiveCount}
          setActiveFreq={setActiveFreq}
          addonItems={ADDON_ITEMS}
          selectedAddons={selectedAddons}
          setSelectedAddons={setSelectedAddons}
        />

        <div className="hidden lg:flex justify-end gap-6 border-t border-white/[12%] pt-10 mt-10 ">
          <div className="w-full lg:w-2/5">
            <span className="block text-white text-4xl font-medium">
              Итого стоимость:
            </span>
          </div>
          <div className="w-full lg:w-3/5">
            <div>
              <span
                className={cn(
                  'block flex justify-between w-full items-baseline text-[#9DCF4E] text-base font-normal leading-[23px]',
                  {
                    '-tracking-[2px]': activeCount === 1001
                  }
                )}
              >
                {activeCount !== 1001 && (
                  <div className="flex justify-between items-baseline w-full">
                    <span className="text-lg">Мониторинг в месяц</span>
                    <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                    <span className="text-2xl">
                      {priceMonthBase.toLocaleString('ru')} ₽
                    </span>
                  </div>
                )}
              </span>
              <span
                className={cn(
                  'block flex justify-between w-full items-baseline text-[#9DCF4E] text-base font-normal leading-[23px]',
                  {
                    '-tracking-[2px]': activeCount === 1001
                  }
                )}
              >
                {activeCount === 1001 &&
                  (() => {
                    const addonsTotalForPeriod =
                      addonsDeltaPerMonth * idMonth + trainingPrice
                    return (
                      <div className="flex justify-between items-baseline w-full">
                        <span className="text-lg">Доп. опции</span>
                        <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                        <span className="text-2xl">
                          {addonsTotalForPeriod.toLocaleString('ru')} ₽
                        </span>
                      </div>
                    )
                  })()}
              </span>
              <span
                className={cn(
                  'block flex justify-between w-full items-baseline text-[#9DCF4E] text-5xl font-normal leading-[47px]',
                  {
                    '-tracking-[2px]': activeCount === 1001,
                    '!text-[32px]':
                      (totalFinal &&
                        totalFinal.toLocaleString('ru').length > 5) ||
                      (totalFinal && totalFinal >= 2000) ||
                      activeCount === 1001
                  }
                )}
              >
                {activeCount === 1001 ?
                  'Персонально'
                : <div className="flex justify-between items-baseline w-full">
                    <span className="text-lg">
                      Всего за {idMonth}{' '}
                      {idMonth === 1 ?
                        'месяц'
                      : idMonth < 5 ?
                        'месяца'
                      : 'месяцев'}
                    </span>
                    <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                    <span className="text-3xl">
                      {totalFinal.toLocaleString('ru')} ₽
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className=" mt-10 text-center">
        <PrimaryButton
          className="w-full lg:w-fit py-10 px-10 lg:py-20 lg:px-24"
          onClick={() =>
            (window.location.href = 'https://go.priceninja.ru/products')
          }
        >
          <span className="block font-semibold lg:font-medium text-[18px] leading-[21px] lg:text-6xl lg:leading-[38px] lg:-tracking-[1px] text-center text-white">
            Мне все нравится, начинаем!
          </span>
        </PrimaryButton>
      </div>
    </div>
  )
}
